/* ==========================================================================
   Bare Babe — Landing Page section kit
   Vanilla JS. No dependencies. Re-initialises on Shopify section load so
   everything stays live inside the Theme Editor.
   ========================================================================== */
(function () {
  'use strict';

  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = parts.join('.');
    if (format && format.indexOf('{{') !== -1) {
      return format.replace(/\{\{\s*\w+\s*\}\}/, amount);
    }
    return '$' + amount;
  }

  /* ---------- Buy box ---------- */
  function initBuyBox(root) {
    if (root.dataset.bblpInit === 'true') return;
    root.dataset.bblpInit = 'true';

    var idInput = root.querySelector('[data-bblp-variant-id]');
    var pills = root.querySelectorAll('[data-bblp-pill]');
    var select = root.querySelector('[data-bblp-select]');
    var priceNow = root.querySelector('[data-bblp-price-now]');
    var priceWas = root.querySelector('[data-bblp-price-was]');
    var submit = root.querySelector('[data-bblp-submit]');
    var submitLabel = root.querySelector('[data-bblp-submit-label]');
    var format = root.dataset.moneyFormat || '';
    var soldOutText = root.dataset.soldOutText || 'Sold out';
    var addText = submitLabel ? submitLabel.textContent : 'Add to cart';

    function apply(el) {
      if (!el) return;
      var price = parseInt(el.dataset.price, 10);
      var compare = parseInt(el.dataset.comparePrice, 10);
      var available = el.dataset.available === 'true';
      if (idInput) idInput.value = el.dataset.variantId;
      if (priceNow && !isNaN(price)) priceNow.textContent = money(price, format);
      if (priceWas) {
        if (!isNaN(compare) && compare > price) {
          priceWas.textContent = money(compare, format);
          priceWas.hidden = false;
        } else {
          priceWas.hidden = true;
        }
      }
      if (submit) submit.disabled = !available;
      if (submitLabel) submitLabel.textContent = available ? addText : soldOutText;
    }

    Array.prototype.forEach.call(pills, function (pill) {
      pill.addEventListener('click', function () {
        if (pill.dataset.available !== 'true' && pill.dataset.allowSoldOut !== 'true') return;
        Array.prototype.forEach.call(pills, function (p) { p.setAttribute('aria-pressed', 'false'); });
        pill.setAttribute('aria-pressed', 'true');
        apply(pill);
      });
    });

    if (select) {
      select.addEventListener('change', function () {
        apply(select.options[select.selectedIndex]);
      });
      apply(select.options[select.selectedIndex]);
    } else {
      var current = root.querySelector('[data-bblp-pill][aria-pressed="true"]') || pills[0];
      apply(current);
    }

    /* Gallery thumbs */
    var thumbs = root.querySelectorAll('[data-bblp-thumb]');
    var mainImg = root.querySelector('[data-bblp-main-image]');
    Array.prototype.forEach.call(thumbs, function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = thumb.dataset.full;
        if (thumb.dataset.srcset) mainImg.srcset = thumb.dataset.srcset;
        mainImg.alt = thumb.dataset.alt || '';
        Array.prototype.forEach.call(thumbs, function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  }

  /* ---------- Modal (size guide) ---------- */
  function initModals(scope) {
    var openers = scope.querySelectorAll('[data-bblp-modal-open]');
    Array.prototype.forEach.call(openers, function (btn) {
      if (btn.dataset.bblpInit === 'true') return;
      btn.dataset.bblpInit = 'true';
      btn.addEventListener('click', function () {
        var modal = document.getElementById(btn.dataset.bblpModalOpen);
        if (!modal) return;
        modal.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        var close = modal.querySelector('[data-bblp-modal-close]');
        if (close) close.focus();
      });
    });

    var modals = scope.querySelectorAll('[data-bblp-modal]');
    Array.prototype.forEach.call(modals, function (modal) {
      if (modal.dataset.bblpInit === 'true') return;
      modal.dataset.bblpInit = 'true';
      function close() {
        modal.hidden = true;
        document.documentElement.style.overflow = '';
      }
      modal.addEventListener('click', function (e) {
        if (e.target === modal || e.target.hasAttribute('data-bblp-modal-close')) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) close();
      });
    });
  }

  /* ---------- Carousel arrows ---------- */
  function initCarousels(scope) {
    var carousels = scope.querySelectorAll('[data-bblp-carousel]');
    Array.prototype.forEach.call(carousels, function (wrap) {
      if (wrap.dataset.bblpInit === 'true') return;
      wrap.dataset.bblpInit = 'true';
      var track = wrap.querySelector('[data-bblp-track]');
      if (!track) return;
      var prev = wrap.querySelector('[data-bblp-prev]');
      var next = wrap.querySelector('[data-bblp-next]');
      function step(dir) {
        var first = track.firstElementChild;
        var amount = first ? first.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
        track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
    });
  }

  /* ---------- Lazy video play ---------- */
  function initVideos(scope) {
    var frames = scope.querySelectorAll('[data-bblp-video-play]');
    Array.prototype.forEach.call(frames, function (btn) {
      if (btn.dataset.bblpInit === 'true') return;
      btn.dataset.bblpInit = 'true';
      btn.addEventListener('click', function () {
        var frame = btn.closest('[data-bblp-video-frame]');
        if (!frame) return;
        var video = frame.querySelector('video');
        var embed = frame.querySelector('[data-bblp-embed-src]');
        if (video) { video.controls = true; video.play(); }
        if (embed) {
          var iframe = document.createElement('iframe');
          iframe.src = embed.dataset.bblpEmbedSrc;
          iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
          iframe.setAttribute('allowfullscreen', 'true');
          iframe.setAttribute('title', embed.dataset.title || 'Video');
          embed.replaceWith(iframe);
        }
        btn.remove();
      });
    });
  }

  /* ---------- Sticky CTA ---------- */
  function initSticky(scope) {
    var bars = scope.querySelectorAll('[data-bblp-sticky]');
    Array.prototype.forEach.call(bars, function (bar) {
      if (bar.dataset.bblpInit === 'true') return;
      bar.dataset.bblpInit = 'true';
      var after = parseInt(bar.dataset.showAfter, 10) || 600;
      function onScroll() {
        if (window.pageYOffset > after) bar.classList.add('is-visible');
        else bar.classList.remove('is-visible');
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    });
  }

  function initAll(scope) {
    scope = scope || document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-bblp-buybox]'), initBuyBox);
    initModals(scope);
    initCarousels(scope);
    initVideos(scope);
    initSticky(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) { initAll(e.target); });
})();

/* Before / after slider — appended module */
(function () {
  'use strict';
  function initBA(scope) {
    var els = (scope || document).querySelectorAll('[data-bblp-ba]');
    Array.prototype.forEach.call(els, function (el) {
      if (el.dataset.bblpInit === 'true') return;
      el.dataset.bblpInit = 'true';
      var range = el.querySelector('[data-bblp-ba-range]');
      if (!range) return;
      function set(v) { el.style.setProperty('--bblp-ba-pos', v + '%'); }
      range.addEventListener('input', function () { set(range.value); });
      set(range.value);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initBA(document); });
  } else { initBA(document); }
  document.addEventListener('shopify:section:load', function (e) { initBA(e.target); });
})();
